/**
 * A generic form for renaming things, based on
 * https://basecamp.com/1824967/projects/4444406/messages/27301769?enlarge=98157420#attachment_98157420
 *
 * When constructing this view, pass in
 * 1) title, which may be a resource bundle key
 * 2) model, which may be any Backbone Model
 */
import Backbone from 'backbone'

import template from './rename-form.hbs'
import i18n from 'scoreboard/components/i18n'
import FormView from 'scoreboard/components/form-view'
import MarkedField from 'scoreboard/components/marked-field'
import requiredValidator from 'scoreboard/components/validators/required-validator'
import _ from 'lodash'

var RenameForm = Backbone.View.extend({

	// this.model is whatever is being renamed

	tagName: 'form',

	className: 'rename-form',

	initialize: function(options) {
		this.options = options

		this.formView = new FormView({ el: this.el, submit: this.save.bind(this) })
	},

	render: function() {
		var context =
		this.$el.append(template({
			title: i18n.get(this.options.title),
			label: this.model.get('label')
		}))

		this.labelField = new MarkedField({
			el: this.$('[name=label]'),
			validator: requiredValidator
		}).render()

		this.formView.start({
			isNew: this.model.isNew()
		})

		return this
	},

	save: function(e) {
		var self = this
		// other views that are rendering this model should
		// listen to this change and update themselves automatically
		this.model.save({
			label: this.$('.label').val(),
			// This is so OrganizationRenamer doesn't try to update the entire
			// dataset template tree
			forceSingleOrgRename: true
		}, { patch: true })
		Backbone.trigger('edit:domain-object', this.model)
		this.trigger('done')
		e.preventDefault()
	},

	remove: function () {
		Backbone.View.prototype.remove.apply(this, arguments)
		_.invokeMap([this.formView, this.labelField], 'remove')
	}

})

export default RenameForm

RenameForm.__filename__ = 'organizations/rename-form.js'
